import { UpdateStagedTripBulkInput, UpdateStagedTripInput, UpdateStagedTripValuesInput } from '@/models/gen/graphql';
import { isNil, queryInput } from '@/utils';

import { UpdateStagedTripBulkDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

const [runUpdateStagedTripBulk] = graphApi(UpdateStagedTripBulkDocument);

const updateStagedTripBulk = async (ids: string[], payload: UpdateStagedTripValuesInput) => {
  const input: UpdateStagedTripBulkInput = {
    updates: [
      {
        query: [{ id: queryInput(ids) }],
        value: {
          airportCode: payload.airportCode ? queryInput(payload.airportCode) : null,
          attendants: payload.attendants ? queryInput(payload.attendants) : null,
          bufferMinutes: payload.bufferMinutes ? queryInput(payload.bufferMinutes) : null,
          combineId: payload.combineId ? queryInput(payload.combineId) : null,
          companyId: payload.companyId ? queryInput(payload.companyId) : null,
          crewId: payload.crewId ? queryInput(payload.crewId) : null,
          doLocationId: payload.doLocationId ? queryInput(payload.doLocationId) : null,
          firstName: payload.firstName ? queryInput(payload.firstName) : null,
          flightNumber: payload.flightNumber ? queryInput(payload.flightNumber) : null,
          fromManifest: !isNil(payload.fromManifest) ? queryInput(payload.fromManifest ? 1 : 0) : null,
          importId: payload.importId ? queryInput(payload.importId) : null,
          importTime: payload.importTime ? queryInput(payload.importTime) : null,
          ingestAction: payload.ingestAction ? queryInput(payload.ingestAction) : null,
          kind: payload.kind ? queryInput(payload.kind) : null,
          lastName: payload.lastName ? queryInput(payload.lastName) : null,
          loopName: payload.loopName ? queryInput(payload.loopName) : null,
          payerProviderId: payload.payerProviderId ? queryInput(payload.payerProviderId) : null,
          pilots: payload.pilots ? queryInput(payload.pilots) : null,
          potentialTripId: payload.potentialTripId ? queryInput(payload.potentialTripId) : null,
          puLocationId: payload.puLocationId ? queryInput(payload.puLocationId) : null,
          scheduled: payload.scheduled ? queryInput(payload.scheduled) : null,
          servicerIataAirlineCode: payload.servicerIataAirlineCode ? queryInput(payload.servicerIataAirlineCode) : null,
          split: !isNil(payload.split) ? queryInput(payload.split ? 1 : 0) : null,
          statusName: payload.statusName ? queryInput(payload.statusName) : null,
          traceId: payload.traceId ? queryInput(payload.traceId) : null,
          tripId: payload.tripId ? queryInput(payload.tripId) : null,
          typeName: payload.typeName ? queryInput(payload.typeName) : null,
        },
      },
    ],
  };
  const res = await runUpdateStagedTripBulk({ input });

  return res?.updateStagedTripBulk?.response;
};

const updateStagedTripBulkWithPayload = async (updates: UpdateStagedTripInput[]) => {
  const input: UpdateStagedTripBulkInput = { updates };
  console.log('updateStagedTripBulkWithPayload: input', input);
  const res = await runUpdateStagedTripBulk({ input });
  console.log('updateStagedTripBulkWithPayload: res', res);
  return res?.updateStagedTripBulk?.response;
};

export const useUpdateStagedTripBulk = createGraphApiHook(updateStagedTripBulkWithPayload);

export default updateStagedTripBulk;
